/**
 * Live viewer count badge. Shows a plausible, slowly fluctuating number to
 * reinforce urgency — not connected to real traffic data.
 */
class ViewerCountBadge extends HTMLElement {
  connectedCallback() {
    this.min = parseInt(this.dataset.min || '5', 10);
    this.max = parseInt(this.dataset.max || '20', 10);
    this.template = this.dataset.template || '[count] people are viewing this right now';
    this.textEl = this.querySelector('.viewer-count-badge__text');
    this.count = this.randomInRange(this.min, this.max);
    this.render();
    this.scheduleNudge();
  }

  disconnectedCallback() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  randomInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  scheduleNudge() {
    this.timeout = setTimeout(() => this.nudge(), this.randomInRange(8000, 16000));
  }

  nudge() {
    const delta = this.randomInRange(-2, 2);
    this.count = Math.min(this.max, Math.max(this.min, this.count + delta));
    this.render();
    this.scheduleNudge();
  }

  render() {
    if (this.textEl) this.textEl.textContent = this.template.replace('[count]', this.count);
  }
}

if (!customElements.get('viewer-count-badge')) {
  customElements.define('viewer-count-badge', ViewerCountBadge);
}

/**
 * Discount code banner. Copies the code to the clipboard on click.
 */
class DiscountCodeBanner extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-copy-code]');
    this.codeEl = this.querySelector('[data-discount-code]');
    if (!this.button || !this.codeEl) return;
    this.defaultText = this.button.textContent;
    this.copiedText = this.dataset.copiedText || 'Copied!';
    this.button.addEventListener('click', () => this.copy());
  }

  copy() {
    const code = this.codeEl.dataset.discountCode || this.codeEl.textContent;
    navigator.clipboard.writeText(code).then(() => {
      this.button.textContent = this.copiedText;
      this.button.setAttribute('data-copied', '');
      setTimeout(() => {
        this.button.textContent = this.defaultText;
        this.button.removeAttribute('data-copied');
      }, 2000);
    });
  }
}

if (!customElements.get('discount-code-banner')) {
  customElements.define('discount-code-banner', DiscountCodeBanner);
}
